import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../environments/environment';
import StorageKeys from '../constants/storage';

import { StorageService } from './storage.service';
import { SocketService } from './socket.service';

/**
 * App Initializer Service
 * Loads application configuration before the app starts
 */
@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {
  private configuration: any = null;

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private socketService: SocketService
  ) { }

  /**
   * Gets the stored configuration
   */
  getConfiguration(): any {
    return this.configuration;
  }

  /**
   * Initializes the application by loading configuration from the API
   * This method is called during app initialization (before the app starts)
   * @returns Promise that resolves when configuration is loaded
   */
  initializeApp(): Promise<any> {
    return new Promise((resolve, reject) => {
      // Capture UTM params from the landing URL before routing strips the query string
      this.storageService.captureUtmParams();

      // Initialise presence socket after session is restored
      const identifier = this.storageService.getSessionId();

      // Connect to presence socket if enabled
      if (environment.SOCKET_PRESENCE?.ENABLED) {
        const userName = this.storageService.getItemFromSessionStorage(StorageKeys.CONTACT_DETAILS)?.firstName;
        this.socketService.connectPresence(identifier, userName);
      }
      const configUrl = `${environment.API_URL}/v1/ui-configuration?acquisitionParty=${environment.SUB_MODULE}`;

      firstValueFrom(this.http.get(configUrl))
        .then((config: any) => {
          this.configuration = config;
          resolve(config);
        })
        .catch((error) => {
          console.error('Failed to load application configuration:', error);
          // You can choose to reject or resolve with default config
          // Option 1: Reject to prevent app startup if config is critical
          // reject(error);

          // Option 2: Resolve with default config to allow app to start
          this.configuration = this.getDefaultConfiguration();
          console.warn('Using default configuration');
          resolve(this.configuration);
        });
    });
  }

  /**
   * Returns default configuration in case API call fails
   */
  private getDefaultConfiguration(): any {
    return {
      // Add your default configuration values here
      featureFlags: {},
      apiTimeout: 30000,
      retryAttempts: 3
    };
  }
}
